export default __webpack_public_path__ + "static/media/consultorio.ed0ea0ea.png";